import { createReducer, on } from "@ngrx/store";
import { initalFeatureState } from "./feature-management.state";
import { UserActions } from "../../common/state/user/user.actions";
import { FeatureManagementActions } from "./feature-management.actions";
import { onLoadableError, onLoadableLoad, onLoadableSuccess } from "../../common/models";
import { arrayToILoadableWrapperArray, createDefaultLoadable } from "../../common/models/loadable";
import { addFeature, clearFeatures, removeFeature, replaceFeature, setFeatureLoading } from "./helpers";

export const featureManagementReducer = createReducer(
    initalFeatureState,
    on(FeatureManagementActions.loadFeatures, state => ({
        features: onLoadableLoad({
            ...state.features
        })
    })),
    on(FeatureManagementActions.loadFeaturesSuccess, (state, { features }) => ({
        features: onLoadableSuccess({
            ...state.features,
            items: arrayToILoadableWrapperArray(features)
        })
    })),
    on(FeatureManagementActions.loadFeaturesFailure, (state, { error }) => ({
        features: onLoadableError({ ...state.features }, error)
    })),
    on(FeatureManagementActions.clearFeatures, _ => ({
        features: {
            ...createDefaultLoadable(),
            items: clearFeatures()
        }
    })),

    on(FeatureManagementActions.addFeature, (state, { }) => ({
        features: onLoadableLoad(state.features)
    })),
    on(FeatureManagementActions.addFeatureSuccess, (state, { feature }) => ({
        features: onLoadableSuccess({
            ...state.features,
            items: addFeature(state.features.items, feature)
        })
    })),
    on(FeatureManagementActions.addFeatureFailure, (state, { error }) => ({
        features: onLoadableError(state.features, error)
    })),

    on(FeatureManagementActions.modifyFeature, (state, { }) => ({
        features: onLoadableLoad(state.features)
    })),
    on(FeatureManagementActions.modifyFeatureSuccess, (state, { feature }) => ({
        features: onLoadableSuccess({
            ...state.features,
            items: replaceFeature(state.features.items, feature)
        })
    })),
    on(FeatureManagementActions.modifyFeatureFailure, (state, { error }) => ({
        features: onLoadableError(state.features, error)
    })),

    on(FeatureManagementActions.deleteFeature, (state, { feature }) => ({
        features: onLoadableLoad({
            ...state.features,
            items: setFeatureLoading(state.features.items, feature)
        })
    })),
    on(FeatureManagementActions.deleteFeatureSuccess, (state, { feature }) => ({
        features: onLoadableSuccess({
            ...state.features,
            items: removeFeature(state.features.items, feature)
        })
    })),
    on(FeatureManagementActions.deleteFeatureFailure, (state, { error }) => ({
        features: onLoadableError(state.features, error)
    })),

    on(UserActions.logout, _ => ({ ...initalFeatureState })),
);
